import { render, staticRenderFns } from "./ValidationAlert.vue?vue&type=template&id=3bc51a46&"
import script from "./ValidationAlert.vue?vue&type=script&lang=js&"
export * from "./ValidationAlert.vue?vue&type=script&lang=js&"
import style0 from "./ValidationAlert.vue?vue&type=style&index=0&id=3bc51a46&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports